/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Locking_Initiated_Via_SsInputs */

const en_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email locking initiated via SSO provider.`)
};

const es_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueo de correo electrónico iniciado a través del proveedor SSO.`)
};

const fr_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouillage de l'e-mail initié via le fournisseur SSO.`)
};

const de_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Sperre über SSO-Anbieter initiiert.`)
};

const ja_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSOプロバイダー経由でメールのロックが開始されました。`)
};

const zh_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已通过 SSO 提供商启动邮箱锁定。`)
};

const ar_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم بدء قفل البريد الإلكتروني عبر مزود تسجيل الدخول الموحد (SSO).`)
};

const id_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penguncian email diinisiasi via penyedia SSO.`)
};

const it_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocco e-mail avviato tramite provider SSO.`)
};

const ru_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Блокировка электронной почты инициирована через провайдера SSO.`)
};

const pt_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueio de e-mail iniciado via provedor de SSO.`)
};

const ko_email_locking_initiated_via_ss = /** @type {(inputs: Email_Locking_Initiated_Via_SsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSO 제공자를 통해 이메일 잠금이 시작되었습니다.`)
};

/**
* | output |
* | --- |
* | "Email locking initiated via SSO provider." |
*
* @param {Email_Locking_Initiated_Via_SsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const email_locking_initiated_via_ss = /** @type {((inputs?: Email_Locking_Initiated_Via_SsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Locking_Initiated_Via_SsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_locking_initiated_via_ss(inputs)
	if (locale === "es") return es_email_locking_initiated_via_ss(inputs)
	if (locale === "fr") return fr_email_locking_initiated_via_ss(inputs)
	if (locale === "de") return de_email_locking_initiated_via_ss(inputs)
	if (locale === "ja") return ja_email_locking_initiated_via_ss(inputs)
	if (locale === "zh") return zh_email_locking_initiated_via_ss(inputs)
	if (locale === "ar") return ar_email_locking_initiated_via_ss(inputs)
	if (locale === "id") return id_email_locking_initiated_via_ss(inputs)
	if (locale === "it") return it_email_locking_initiated_via_ss(inputs)
	if (locale === "ru") return ru_email_locking_initiated_via_ss(inputs)
	if (locale === "pt") return pt_email_locking_initiated_via_ss(inputs)
	return ko_email_locking_initiated_via_ss(inputs)
});